import { createStyles, Theme } from '@material-ui/core';

const styles = ({ colors, spacing }: Theme) => createStyles({
  rowDistance: {
    marginBottom: `${colors.pageElements.serviceCard.rowsDistance}px`,
  },
  mb2: {
    marginBottom: `${spacing(2)}px`,
  },
  mt6: {
    marginTop: `${spacing(6)}px`,
  },
});

export default styles;
